import {createAction} from 'redux-actions'

// fetch new i18n data
export let switchLanguage = createAction('SWITCH_LANGUAGE', language => ({language}))

// make switched language active
export let setLanguage = createAction('SET_LANGUAGE', ({language, dname, i18ndata, cacheKeys}) => ({
  language,
  dname,
  i18ndata,
  cacheKeys,
}))
